"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { d: "M10 13C10 11.8954 10.8954 11 12 11H28C29.1046 11 30 11.8954 30 13C30 14.1046 29.1046 15 28 15H12C10.8954 15 10 14.1046 10 13Z", fill: colour }),
        react_1.default.createElement("path", { d: "M10 20C10 18.8954 10.8954 18 12 18H21C22.1046 18 23 18.8954 23 20C23 21.1046 22.1046 22 21 22H12C10.8954 22 10 21.1046 10 20Z", fill: colour }),
        react_1.default.createElement("path", { d: "M10 27C10 25.8954 10.8954 25 12 25H28C29.1046 25 30 25.8954 30 27C30 28.1046 29.1046 29 28 29H12C10.8954 29 10 28.1046 10 27Z", fill: colour })));
};
//# sourceMappingURL=List.js.map